import {isMobile} from 'react-device-detect';
import {config} from "../config";
import utils from "../utils";

const ShipmentInfo = (props) => {
 
    let {awbInfo, lastStatus } = props;
    
    awbInfo = awbInfo ? awbInfo : {};
    lastStatus = lastStatus ?  utils.mapStatus(lastStatus, true) : "No status available";
    
    const { prefix, serial, origin, dest, pieces, weight, volume } = awbInfo;
    
    return (
         <section style={{ padding : "0"}}>
            <div className = "card secondary" id = "awb_info">
                
                <div className = "columns eleven" style = {{margin : 0, padding : 0}}>
                    
                    <section>
                    
                        <div className="columns two">
                            <h3 style={{color : config.majorColor, margin : 0, padding : 0 }}> 
                                Shipment Info
                            </h3>
                        </div>

                    <div className="columns ten">

                        <table className="" >
                        
                        <thead>
                            <tr>
                            <th>AWB number</th>
                            <th>{isMobile ? "Orig" : "Origin"}</th>
                            <th>{isMobile ? "Dest" : "Destination"}</th>
                            <th>{isMobile ? "Pcs" : "Pieces"}</th>
                            <th>{isMobile ? "Wgt" : "Weight"}</th>
                            <th>{isMobile ? "Vol" : "Volume"}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                            <td>{prefix} - {serial}</td>
                            <td>{origin}</td>
                            <td>{dest}</td>
                            <td>{pieces} </td>            
                            <td>{weight} kg</td>
                            <td>{parseFloat(volume).toFixed(1)} m³</td>
                            </tr>
                        </tbody>

                        </table>

                        <span> 
                            <strong style={{color:"#003366"}}> Last status: </strong> 
                            {!isMobile ? 
                                lastStatus : 
                                <>
                                {lastStatus.split("---")[0] }
                                <br/> 
                                {lastStatus.split("---")[1]}
                                </>
                            } 
                        </span>

                    </div>
            
                    </section>
                </div>
            </div>
        </section>
    );
};
export default ShipmentInfo;